import { CalendarDays, Fingerprint, Mic, Tag, UserRound } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { ConnectionLines, GraphicCard, IllustrationFrame, VerifiedPill } from './shared'

/** The subject's record: a person, and beside it the rail of encounters that everything hangs on. */
function SubjectRecord({ label }: { label: string }) {
  return (
    <g>
      <rect
        x="70"
        y="56"
        width="150"
        height="180"
        rx="16"
        className="fill-card stroke-primary/40"
      />
      <circle cx="145" cy="100" r="25" className="fill-primary/10" />
      <UserRound x="133" y="88" width="24" height="24" className="text-primary-strong" />
      <text x="145" y="150" textAnchor="middle" className="fill-foreground text-xs font-semibold">
        {label}
      </text>
      <path
        d="M116 168H174"
        className="stroke-muted-foreground/20"
        strokeWidth="4"
        strokeLinecap="round"
      />
      {/* what the record keeps on the person: a mark, a voice, a fingerprint */}
      <rect x="98" y="188" width="26" height="26" rx="8" className="fill-primary/10" />
      <Tag x="104" y="194" width="14" height="14" className="text-primary-strong" />
      <rect x="132" y="188" width="26" height="26" rx="8" className="fill-primary/10" />
      <Mic x="138" y="194" width="14" height="14" className="text-primary-strong" />
      <rect x="166" y="188" width="26" height="26" rx="8" className="fill-primary/10" />
      <Fingerprint x="172" y="194" width="14" height="14" className="text-primary-strong" />
      {/* the rail: one dot per encounter, in the order they happened */}
      <path d="M262 64V226" className="stroke-primary/30" strokeWidth="2" strokeLinecap="round" />
      <circle cx="262" cy="80" r="6" className="fill-primary" />
      <circle cx="262" cy="145" r="6" className="fill-primary" />
      <circle
        cx="262"
        cy="212"
        r="6"
        className="fill-primary/40 stroke-primary"
        strokeWidth="1.5"
      />
    </g>
  )
}

export function HumintWorkspaceIllustration() {
  const { t } = useTranslation()
  const key = 'whatsNew.slides.humintWorkspace.graphic'
  return (
    <IllustrationFrame label={t(`${key}.description`)}>
      <ConnectionLines d="M220 145H262 M268 80H433 M268 145H466 M268 212H405" />
      <SubjectRecord label={t(`${key}.subject`)} />
      <GraphicCard card={{ x: 433, y: 51, label: t(`${key}.encounters`), icon: CalendarDays }} />
      <GraphicCard card={{ x: 466, y: 116, label: t(`${key}.questioning`), icon: Mic }} />
      <GraphicCard card={{ x: 405, y: 183, label: t(`${key}.marks`), icon: Tag }} />
      <VerifiedPill label={t(`${key}.traceable`)} y={252} />
    </IllustrationFrame>
  )
}
